import './env.d';

import { z } from 'zod/v4';

const ENV_SCHEMA = z.object({
  VITE_FIREBASE_API_KEY: z.string().length(39),
  VITE_FIREBASE_AUTH_DOMAIN: z.string().regex(/^[a-z0-9-]+.firebaseapp.com$/),
  VITE_FIREBASE_PROJECT_ID: z.string().regex(/^[a-z0-9-]+$/),
  VITE_FIREBASE_STORAGE_BUCKET: z
    .string()
    .regex(/^[a-z0-9-]+.firebasestorage.app$/),
  VITE_FIREBASE_MESSAGING_SENDER_ID: z.string().regex(/^\d{12}$/),
  VITE_FIREBASE_APP_ID: z.string().regex(/^1:\d{12}:web:[\da-f]{22}$/),
  VITE_API_URL: z.url(),
  VITE_MATOMO_URL: z.string().optional(),
  VITE_MATOMO_SITE_ID: z.string().optional(),
});

ENV_SCHEMA.parse(import.meta.env);
